import React, { useEffect, useState } from "react";
import './CountdownTimer.css';
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CountdownTimer = ({ small, endTime }) => {
    const { t } = useTranslation();
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, totalSeconds: 0 });

    const [isAuctionEnded, setIsAuctionEnded] = useState(false);
    const [pulse, setPulse] = useState(false);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date();
            const endDate = new Date(endTime);
            const diff = endDate - now;

            if (diff <= 0) {
                setIsAuctionEnded(true);
                setPulse(false);
                return;
            }

            const totalSeconds = Math.floor(diff / 1000);
            const days = Math.floor(totalSeconds / (60 * 60 * 24));
            const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            setTimeLeft({ days, hours, minutes, seconds, totalSeconds });
            setPulse(true);
        };

        calculateTimeLeft();

        const interval = setInterval(() => {
            calculateTimeLeft();
            setTimeout(() => setPulse(false), 50);
        }, 1000);

        return () => clearInterval(interval);
    }, [endTime]);

    if (isAuctionEnded) {
        return <span>{t("countdown_timer.auction_ended")}</span>;
    }

    const pad = (num) => String(num).padStart(2, '0');

    if (small) {
        if (timeLeft.days > 0) {
            return (

                <Typography color="primary" variant="body">
                    {timeLeft.days > 0 && `${timeLeft.days} ${t("countdown_timer.days")} `}
                    {(timeLeft.hours > 0) && `${timeLeft.hours} ${t("countdown_timer.hours")} `}
                    {(timeLeft.minutes > 3) && `${timeLeft.minutes} ${t("countdown_timer.minutes")} `}

                </Typography>
            );
        }
        if (timeLeft.hours > 0) {
            return (

                <Typography color="primary" variant="body">
                    {(timeLeft.hours > 0) && `${timeLeft.hours} ${t("countdown_timer.hours")} `}
                    {(timeLeft.minutes > 3) && `${timeLeft.minutes} ${t("countdown_timer.minutes")} `}
                    <span
                        key={timeLeft.seconds}
                        className={`countdown-seconds ${timeLeft.totalSeconds < 180 ? 'animated' : ''}`}
                    >
                        {(timeLeft.minutes <= 3) ? timeLeft.minutes + " " + t("countdown_timer.minutes") + " " : null}
                        {pad(timeLeft.seconds) + " " + t("countdown_timer.seconds")}
                    </span>
                </Typography>
            );
        } else {
            return (

                <Typography color="primary" variant="body">
                    {(timeLeft.minutes > 3) && `${timeLeft.minutes} ${t("countdown_timer.minutes")} `}
                    <span
                        key={timeLeft.seconds}
                        className={`countdown-seconds ${timeLeft.totalSeconds < 180 ? 'animated' : ''}`}
                    >
                        {(timeLeft.minutes <= 3) ? timeLeft.minutes + " " + t("countdown_timer.minutes") + " " : null}
                        {pad(timeLeft.seconds) + " " + t("countdown_timer.seconds")}
                    </span>
                </Typography>
            );
        }
    }
    return (

        <Typography color="primary" variant="body">
            {timeLeft.days > 0 && `${timeLeft.days} ${t("countdown_timer.days")} `}
            {(timeLeft.hours > 0) && `${timeLeft.hours} ${t("countdown_timer.hours")} `}
            {(timeLeft.minutes > 3) && `${timeLeft.minutes} ${t("countdown_timer.minutes")} `}
            <span
                key={timeLeft.seconds}
                className={`countdown-seconds ${timeLeft.totalSeconds < 180 ? 'animated' : ''}`}
            >
                {(timeLeft.minutes <= 3) ? timeLeft.minutes + " " + t("countdown_timer.minutes") + " " : null}
                {pad(timeLeft.seconds) + " " + t("countdown_timer.seconds")}
            </span>

        </Typography>
    );
};

export default CountdownTimer;
